module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Adjust-18b169524a5c2e0af320a1baf0d9a9b0.svg";